import React from "react";
import { motion } from "framer-motion";

export const Kicker = ({ children }) => (
  <div className="flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase text-white/50 mb-6">
    <span className="h-px w-8 bg-[#B18B5E]" />
    {children}
  </div>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2
    className={`font-display font-light tracking-[-0.02em] leading-[1.02] text-white ${className}`}
    style={{ fontSize: "clamp(2.25rem, 5vw, 4.25rem)" }}
  >
    {children}
  </h2>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
